import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ErrorAlert } from '@/components/ErrorAlert';
import { PageHeader } from '@/components/PageHeader';
import { PlainText } from '@/components/PlainText';
import { formatDate } from '@/lib/format';
import { orpc } from '@/lib/orpc';

export const Route = createFileRoute('/_app/assistants')({ component: AssistantsPage });

/** Published profiles only. Deliberately no status, no activity indicator (PLAN.md §9). */
function AssistantsPage() {
  const { t } = useTranslation();
  const profiles = useQuery(orpc.profiles.list.queryOptions());
  return (
    <div>
      <PageHeader title={t('assistants.title')} lead={t('assistants.lead')} />
      {profiles.isError && <ErrorAlert error={profiles.error} />}
      <div className="grid gap-4 md:grid-cols-2">
        {profiles.data?.map((p) => (
          <section key={p.userId} className="card bg-base-100 shadow-sm">
            <div className="card-body">
              <h2 className="card-title text-base">{p.name}</h2>
              <p className="text-base-content/60 text-xs">{p.email}</p>
              {p.profile ? <PlainText text={p.profile} /> : <p className="text-base-content/50 text-sm">{t('assistants.noProfile')}</p>}
              {p.updatedAt && <p className="text-base-content/40 text-xs">{formatDate(p.updatedAt)}</p>}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
